import { notifications } from 'lib/axios';

export const getRecentNotifications = ({ type, pageNumber }) => {
  console.log(`recent notifications`);
  return notifications.get(`/admin/recent/${type}/${pageNumber}`);
};

export const useRecentNotifications = ({ type, pageNumber }) => {
  return {
    queryFn: () => getRecentNotifications({ type, pageNumber }),
  };
};
